import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { PatternType, StoredPattern } from '../types/pattern.model';

export type Page = 'home' | 'new' | 'edit' | 'collections' | 'collection-detail';

export interface PatternManagerState {
  page: Page;
  previousPages: Page[];
  patternType: PatternType | null;
  currentPattern: StoredPattern | null;
  currentCollectionId: string | null;
}

const initialState: PatternManagerState = {
  page: 'home',
  previousPages: [],
  patternType: null,
  currentPattern: null,
  currentCollectionId: null,
};

export const patternManagerSlice = createSlice({
  name: 'pattern-manager',
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<Page>) => {
      state.previousPages.push(state.page);
      state.page = action.payload;
    },
    backPage: (state) => {
      const previousPage = state.previousPages.pop();
      if (previousPage) {
        state.page = previousPage;
      }
    },
    setPatternType: (state, action: PayloadAction<PatternType | null>) => {
      state.patternType = action.payload;
    },
    setCurrentPattern: (state, action: PayloadAction<StoredPattern | null>) => {
      state.currentPattern = action.payload;
    },
    setCurrentCollectionId: (state, action: PayloadAction<string | null>) => {
      state.currentCollectionId = action.payload;
    },
  },
});

export const { setPage, backPage, setPatternType, setCurrentPattern, setCurrentCollectionId } = patternManagerSlice.actions;

export const selectPage = (state: RootState) => state.patternManager.page;

export const selectPatternType = (state: RootState) => state.patternManager.patternType;

export const selectCurrentPattern = (state: RootState) => state.patternManager.currentPattern;

export const selectCurrentCollectionId = (state: RootState) => state.patternManager.currentCollectionId;

export default patternManagerSlice.reducer;
